export default "__VITE_ASSET__BER9xyWg__"